import { useAuth } from '../context/AuthContext';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.clawyee.com/api';

export async function apiRequest(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;
  console.log('[ApiClient] Starting request:', options.method || 'GET', url);

  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  console.log('[ApiClient] Response status:', response.status);

  const data = await response.json();

  console.log('[ApiClient] Response data:', data);

  if (!response.ok) {
    throw new Error(data.error || `API request failed: ${response.status}`);
  }

  return data;
}

export function createApiClient(getAccessToken) {
  return {
    async get(endpoint) {
      const token = getAccessToken();
      console.log('[ApiClient] GET request:', endpoint, 'Token:', token ? 'present' : 'missing');
      return apiRequest(endpoint, {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
    },

    async post(endpoint, body) {
      const token = getAccessToken();
      return apiRequest(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      });
    },

    async put(endpoint, body) {
      const token = getAccessToken();
      return apiRequest(endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      });
    },

    async del(endpoint) {
      const token = getAccessToken();
      return apiRequest(endpoint, {
        method: 'DELETE',
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
    },
  };
}

export { API_BASE };